// extracted by mini-css-extract-plugin
export var linkText = "_o4-0";